import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export function useTabParam<T extends string>(
  defaultTab: T,
): [string, (tab: T) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const active = searchParams.get("tab") ?? defaultTab;

  const setTab = useCallback(
    (tab: T) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (tab === defaultTab) {
            next.delete("tab");
          } else {
            next.set("tab", tab);
          }
          return next;
        },
        { replace: true },
      );
    },
    [defaultTab, setSearchParams],
  );

  return [active, setTab];
}
